import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackImportedAsset.meta';

export type UseTrackImportedAssetParams = {
  asset_id: string;
  clip_id: string;
  file_name: string;
};

export const useTrackImportedAsset = () => {
  const { track } = useAnalyticsUtilities();

  const trackImportedAsset = useCallback(
    (params: UseTrackImportedAssetParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackImportedAsset };
};
